export const pad = (n) => String(n).padStart(2, "0");
export const toISO = (d) => `${d.getFullYear()}-${pad(d.getMonth() + 1)}-${pad(d.getDate())}`;
export const parseISO = (s) => {
  const [y, m, d] = s.split("-").map(Number);
  return new Date(y, m - 1, d);
};
export const todayISO = () => toISO(new Date());
export const addDays = (iso, n) => {
  const d = parseISO(iso);
  d.setDate(d.getDate() + n);
  return toISO(d);
};
export const weekStart = (iso) => {
  const d = parseISO(iso);
  const wd = (d.getDay() + 6) % 7;
  d.setDate(d.getDate() - wd);
  return toISO(d);
};
export const daysBetween = (a, b) => Math.round((parseISO(b) - parseISO(a)) / 86400000);
export const fmtDate = (iso) => (iso ? iso.slice(0, 10).split("-").reverse().join("/") : "—");
export const fmtDateTime = (iso) => (iso ? new Date(iso).toLocaleString("it-IT", { dateStyle: "short", timeStyle: "short" }) : "—");
export const fmtLong = (iso) =>
  parseISO(iso).toLocaleDateString("it-IT", { weekday: "long", day: "numeric", month: "long", year: "numeric" });
export const DEFAULT_MONEY_PREFS = { cents: true, hidden: false };
export const moneyPrefs = { ...DEFAULT_MONEY_PREFS };
export const applyMoneyPrefs = (prefs) => {
  Object.assign(moneyPrefs, DEFAULT_MONEY_PREFS, prefs);
};
export const MASK = "**** €";
const EUR0 = new Intl.NumberFormat("it-IT", { style: "currency", currency: "EUR", maximumFractionDigits: 0, useGrouping: "always" });
const EUR2 = new Intl.NumberFormat("it-IT", { style: "currency", currency: "EUR", minimumFractionDigits: 2, maximumFractionDigits: 2, useGrouping: "always" });
export const signTone = (n, neg, pos) => (moneyPrefs.hidden ? "" : n < 0 ? neg : pos);
export const pctText = (p) => (moneyPrefs.hidden ? "**%" : p == null ? "—" : `${p}%`);
export const eur = (n) => {
  if (moneyPrefs.hidden) return MASK;
  return (moneyPrefs.cents ? EUR2 : EUR0).format(n || 0);
};
export const eur2 = (n) => (moneyPrefs.hidden ? MASK : EUR2.format(n || 0));
export const num = (n) => new Intl.NumberFormat("it-IT", { maximumFractionDigits: 1 }).format(n || 0);

const SHIFT_RE = /^([01]\d|2[0-3]):([0-5]\d)-([01]\d|2[0-3]):([0-5]\d)$/;
const toMin = (h, m) => Number(h) * 60 + Number(m);
export const shiftSpan = (shift) => {
  const m = SHIFT_RE.exec((shift || "").replace(/\s/g, ""));
  if (!m) return null;
  const start = toMin(m[1], m[2]);
  const end = toMin(m[3], m[4]);
  return end > start ? [start, end] : null;
};
export const shiftHours = (shift, lunch) => {
  const span = shiftSpan(shift);
  if (!span) return null;
  const brk = shiftSpan(lunch);
  const withBreak = Boolean(brk && span[0] <= brk[0] && brk[1] <= span[1]);
  const minutes = span[1] - span[0] - (withBreak ? brk[1] - brk[0] : 0);
  return { hours: Math.round((minutes / 60) * 100) / 100, withBreak };
};
export const splitShift = (shift) => {
  const [from = "", to = ""] = (shift || "").split("-");
  return [from.trim(), to.trim()];
};

export const ROLE_LABEL = { admin: "Amministratore", responsabile: "Responsabile Cantiere", operaio: "Operaio" };
export const SITE_STATUS = {
  da_avviare: { label: "Da Avviare", cls: "bg-slate-800 border-slate-500 text-slate-200" },
  attivo: { label: "Attivo", cls: "bg-emerald-950 border-emerald-500 text-emerald-300" },
  sospeso: { label: "Sospeso", cls: "bg-amber-950 border-amber-500 text-amber-200" },
  chiuso: { label: "Chiuso", cls: "bg-indigo-950 border-indigo-500 text-indigo-200" },
};
export const AVAIL = {
  disponibile: { label: "Disponibile", dot: "bg-emerald-400", cls: "bg-emerald-950 border-emerald-600 text-emerald-200" },
  impegnato: { label: "Impegnato", dot: "bg-red-500", cls: "bg-red-950 border-red-600 text-red-200" },
  assente: { label: "Assente", dot: "bg-orange-400", cls: "bg-orange-950 border-orange-500 text-orange-200" },
  in_cantiere: { label: "In Cantiere", dot: "bg-sky-400", cls: "bg-sky-950 border-sky-500 text-sky-200" },
  manutenzione: { label: "In Manutenzione", dot: "bg-orange-400", cls: "bg-orange-950 border-orange-500 text-orange-200" },
};
export const DEADLINE_LABEL = {
  patentino: "Patentino", attestato: "Attestato", idoneita: "Idoneità medica",
  revisione: "Revisione", assicurazione: "Assicurazione", bollo: "Bollo",
};
